export const toggleswitch = {
  toggleswitch: {
    height: '1.75rem',
    width: '3rem',
    handleSize: '1.25rem',
  },
};
